import { DesignedCard } from "@with-nx/simple-ui/atoms";
import { Col } from "antd";

export const ScenePreviewCard = ({ scene, index, locked }) => {
  const findAttachment = (name: string) =>
    scene.attachments.find((attachment) => attachment.name === name)?.blob
      .signedUrl;

  const image =
    findAttachment("watermarked_still_thumbnail") ||
    findAttachment("preview_still") ||
    findAttachment("still") ||
    findAttachment("thumbnail");

  const video = locked ? undefined : findAttachment("preview_video");

  const title = () => {
    try {
      return scene.name.split("-")[1].trim();
    } catch (error) {
      return scene.name;
    }
  };

  return (
    <Col xs={24} sm={24} md={12} lg={8}>
      <DesignedCard
        size="16x9"
        video={video}
        image={image}
        playable={!locked}
        watermark={true}
        pop={!locked}
        outside={{
          title: title(),
          subtitle: `Scene ${index + 1}`,
        }}
      />
    </Col>
  );
};
